import { Injectable } from '@angular/core';
import { Unit } from '../../shared/common/units';
import { UnitPipe } from '../feature-pipes/unit.pipe';
import {
  TransformedEnergyDetails,
  getTransformedEnergyDetailsFromValueAndUnit,
} from '../helpers/energy';

@Injectable({
  providedIn: 'root',
})
export class EnergyService {
  constructor(private unitPipe: UnitPipe) {}

  getTransformedEnergyDetailsFromValueAndUnit(
    value: string | number,
    unit: string | Unit,
    returnTransformedUnit = false
  ): TransformedEnergyDetails {
    let transformedEnergyDetails: TransformedEnergyDetails;
    transformedEnergyDetails = getTransformedEnergyDetailsFromValueAndUnit(value, unit);

    if (returnTransformedUnit) {
      transformedEnergyDetails.unit = this.unitPipe.transform(
        transformedEnergyDetails.unit
      ) as Unit;
    }

    return transformedEnergyDetails;
  }
}
